module.exports = __webpack_public_path__ + "static/img/brees-2011-top.bbabcd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2011-top.jpg
// module id = liUv
// module chunks = 1